module.exports = __webpack_public_path__ + "static/tvr-2af5c20e7416dad52a6bc43164014f0e.jpg";